import { getMakeupHairApiBaseUrl } from '../../makeuphair/utils/apiConfig';
import { kioskAuthHeaders } from '../../makeuphair/utils/kioskAuthHeaders';
import { appendFranchiseScopeQueryToPath } from '../../shared/franchiseFlowAuth';
import { imageRefToDataUrl } from '../../shared/imageRefToDataUrl';

function hairBase() {
  return `${getMakeupHairApiBaseUrl().replace(/\/$/, '')}/api/hair-styling`;
}

function withOrg(path) {
  return appendFranchiseScopeQueryToPath(path);
}

async function hairFetch(path, options = {}) {
  const res = await fetch(`${hairBase()}${withOrg(path)}`, {
    credentials: 'include',
    ...options,
    headers: {
      ...kioskAuthHeaders({ 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.success === false) {
    const err = new Error(data?.error || `Request failed (${res.status})`);
    err.code = data?.code;
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function fetchHairColors() {
  return hairFetch('/colors');
}

/** FLUX recolor only — never POST /color (LAB) or OpenCV mask composite unless explicitly requested. */
export async function generateHairColorLook(body) {
  const mode = body.mode || 'hair_color';
  const fluxOnly =
    body.color_flux_only !== false
    && body.color_composite !== true
    && body.use_color_mask_blend !== true;
  return hairFetch('/generate', {
    method: 'POST',
    body: JSON.stringify({
      ...body,
      mode,
      base_image_mode: body.base_image_mode || 'original_capture',
      color_flux_only: fluxOnly,
      color_composite: body.color_composite === true,
      skip_color_composite: fluxOnly,
    }),
  });
}

export async function fetchHairJobStatus(jobId) {
  return hairFetch(`/status/${encodeURIComponent(jobId)}`);
}

export async function fetchHairResultObjectUrl(jobId) {
  const path = withOrg(`/result/${encodeURIComponent(jobId)}`);
  const res = await fetch(`${hairBase()}${path}`, {
    credentials: 'include',
    headers: kioskAuthHeaders(),
  });
  if (!res.ok) {
    const err = new Error(`Result fetch failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}

export async function createHairDownloadUrl(imageRef, name = 'hair-color') {
  const imageDataUrl = await imageRefToDataUrl(imageRef);
  const data = await hairFetch('/download-qr', {
    method: 'POST',
    body: JSON.stringify({ image: imageDataUrl, name }),
  });
  const token = typeof data.token === 'string' ? data.token.trim() : '';
  if (!token) throw new Error('Download link missing');
  return `${hairBase()}/download/${encodeURIComponent(token)}`;
}
